import { Pipe, PipeTransform } from '@angular/core';
import { BookingPartnerDto } from '../dtos/booking/BookingPartnerDto';
import { PartnerCategories } from '../enums/PartnerCategories';

@Pipe({
  name: 'sortPartnerCategories',
  pure: false // opcional si vols que es recalculi automàticament
})
export class SortPartnerCategories implements PipeTransform {

  transform(partnersMap: Map<PartnerCategories, BookingPartnerDto[]>): any[] {
    if (!partnersMap) return [];

    // Convertim el Map en un array de { key, value }
    const array = Array.from(partnersMap.entries()).map(([key, value]) => ({
      key,
      value
    }));

    // Ordenem l’array pel camp key
    array.sort((a, b) => SortPartnerCategories.compareKeys(a.key, b.key));

    return array;
  }

  public static compareKeys(a: any, b: any): number {
    let numberA = SortPartnerCategories.getOrder(a);
    let numberB = SortPartnerCategories.getOrder(b);
    return numberA - numberB;
  }

  /**
   * Mateix ordre en que es mostre en el component de partners de la ruta
   */
  private static getOrder(pc: PartnerCategories): number{
    
    switch(pc){
        case PartnerCategories.Shipper:
            return 0;
        case PartnerCategories.Carrier:
            return 1;
        case PartnerCategories.FreightForwarder:
            return 2;
        case PartnerCategories.LogisticOperator:
            return 3;
        case PartnerCategories.Inspector:
            return 4;
        case PartnerCategories.HealthCertifier:
            return 5;
        case PartnerCategories.ClientPreferent:
            return 6;
        case PartnerCategories.Driver:
            return 7;
        case PartnerCategories.SecondDriver:
            return 8;
        case PartnerCategories.Provider:
            return 9;
        case PartnerCategories.FinalCustomer:
            return 10;
        case PartnerCategories.None:
            return 11;
    }

  }
}